if (!customElements.get('coi-retail-filter')) {
  customElements.define('coi-retail-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.cards = [...this.querySelectorAll('[data-retail-card]')];
      this.controls = [...this.querySelectorAll('[data-retail-filter]')];
      ['format','pack','use'].forEach(key => {
        const select = this.querySelector(`[data-retail-filter="${key}"]`);
        const values = new Set(this.cards.flatMap(card => (card.dataset[key] || '').split('|')).filter(Boolean));
        [...values].sort().forEach(value => select.add(new Option(value, value)));
      });
      this.controls.forEach(control => control.addEventListener('input', () => this.update()));
      this.querySelector('[data-retail-reset]').addEventListener('click', () => {
        this.controls.forEach(control => control.value = '');
        this.update();
      });
      const panel = this.querySelector('[data-retail-controls]');
      panel.open = window.matchMedia('(min-width: 750px)').matches;
      panel.hidden = false;
    }
    update() {
      const selected = Object.fromEntries(this.controls.map(control => [control.dataset.retailFilter, control.value]));
      let count = 0;
      this.cards.forEach(card => {
        const match = ['format','pack','use'].every(key => !selected[key] || (card.dataset[key] || '').split('|').includes(selected[key]))
          && (!selected.availability || card.dataset.available === selected.availability)
          && (selected.min === '' || Number(card.dataset.priceMax) >= Number(selected.min) * 100)
          && (selected.max === '' || Number(card.dataset.priceMin) <= Number(selected.max) * 100);
        card.hidden = !match;
        if (match) count++;
      });
      const status = this.querySelector('[data-retail-count]');
      status.textContent = count === 1 ? status.dataset.single : status.dataset.pattern.replace('__COUNT__', count);
      this.querySelector('[data-retail-empty]').hidden = count !== 0;
    }
  });
}
